module.exports = __webpack_public_path__ + "img/spirit_big_5.8755298c.png";